// Components==============
// import Button from 'components/UI/Button';
import Button from 'components/UI/Button';
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import React from 'react';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import './index.module.scss';
// =========================

export default function InformationModal({
    training,
    isSchoolsTrainingPage,
    training_url,
    basePath = 'groei',
}) {
    const openSubscribe = useOpenUrlModal(`aanmelden`);
    const openInterest = useOpenUrlModal(`interesse`);

    // format start date
    const formattedDate = new Date(training?.start_date).toLocaleDateString(
        'nl-NL',
        {
            timeZone: 'Europe/Amsterdam',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }
    );

    const slug = isSchoolsTrainingPage
        ? `/school-aanbod/${training_url}/training-popup/${training?.id}`
        : `/${basePath}/training-popup/${training?.id}`;

    return (
        <Modal slug={slug} exact>
            <div styleName="wrapper">
                <div styleName="top">
                    <div>
                        <p styleName="label">
                            Meer informatie over | More information about
                        </p>
                        <p styleName="name">{training?.name}</p>
                    </div>
                </div>
                <RichText richText={training?.description} />
                <br />
                {training?.old_link ? null : training?.enrollment_open ? (
                    <>
                        {training?.max_participants <=
                            training?.registrations_count &&
                        training?.max_participants !== null ? (
                            <p>Helaas, deze training zit vol.</p>
                        ) : (
                            <div styleName="sign-in-button-wrapper ">
                                <Button onClick={openSubscribe}>
                                    {isSchoolsTrainingPage
                                        ? 'Aanmelden | Register'
                                        : 'Aanmelden'}
                                </Button>
                                {isSchoolsTrainingPage && (
                                    <p>
                                        Aantal beschikbare plekken | Number of
                                        available spots:{' '}
                                        {training?.max_participants -
                                            training?.registrations_count}
                                    </p>
                                )}
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        {isSchoolsTrainingPage ? (
                            <h3 styleName="registration-closed">
                                De inschrijving voor deze training is gesloten.
                                | The registration for this training has closed.
                            </h3>
                        ) : (
                            <Button onClick={openInterest} background="#169ab5">
                                Interesse aangeven
                            </Button>
                        )}
                    </>
                )}
            </div>
        </Modal>
    );
}
